angular
    .module('WizApp')
    .directive('cookieAcceptanceOpener', [
        'EVENT_NAMES',
        '$rootScope',
        function (EVENT_NAMES, $rootScope) {
            return {
                restrict: 'A',
                scope: {
                    options: '<cookieAcceptanceOpener'
                },
                link: function (scope, element) {
                    element.on('click', event => {

                        $rootScope.$emit(EVENT_NAMES.cookieConsentLightbox.open);
                        scope.$apply();

                        event.stopPropagation();
                        event.preventDefault();
                    });
                }
            };
        }
    ])
;
